import { IOrderParams } from '../../../API/pcDashboard/getOrderAsync';
import { ITasksParams } from '../../../API/pcDashboard/getTasksAsync';
import { cleanMultiSelectQueryRequest } from '../filter/util/cleanMultiSelectQueryRequest';

export const translateOrderParamsToTaskParams = (
  params: Omit<IOrderParams, 'pageNumber' | 'pageSize' | 'sortBy'>
): ITasksParams => {
  const { internalContacts, pageSize, pageNumber, sortBy, ...rest } = cleanMultiSelectQueryRequest(params);

  const defaultParams: ITasksParams = {
    ...rest,
    size: 20,
    page: 0,
    sortProperty: 'dueDate',
    sort: 'desc',
  };
  if (!internalContacts) {
    return defaultParams;
  }
  return {
    ...defaultParams,
    teammates: internalContacts,
  };
};
